import type { LoginResponse } from '@xjlv2/api-client'

/**
 * 格式化并规范化租户域名（小写并去除空格）
 */
export function normalizeTenantDomain(value?: string | null): string {
  return value?.trim().toLowerCase() ?? ''
}

/**
 * 校验并规范化会话数值 ID
 */
function normalizeSessionId(value: number | string, field: string): number {
  const normalized = typeof value === 'string' && value.trim() !== '' ? Number(value) : value
  if (typeof normalized !== 'number' || !Number.isSafeInteger(normalized) || normalized < 0) {
    throw new TypeError(`Invalid ${field} in SaaS session`)
  }
  return normalized
}

/**
 * 结合回退域名解析并校验 SaaS 会话实体
 */
export function withResolvedTenantDomain(session: LoginResponse, fallbackTenantDomain?: string | null): LoginResponse {
  const tenantDomain = normalizeTenantDomain(session.tenantDomain) || normalizeTenantDomain(fallbackTenantDomain)
  return {
    ...session,
    tenantId: normalizeSessionId(session.tenantId, 'tenantId'),
    userId: normalizeSessionId(session.userId, 'userId'),
    deptId: normalizeSessionId(session.deptId, 'deptId'),
    ...(tenantDomain ? { tenantDomain } : {})
  }
}
